import {
  ProductAnalyticsEvent,
  ProductAnalyticsEventV2
} from '@dadohr/shared/domainTypes/productAnalytics';
import { useMemo } from 'react';
import { matchPath } from 'react-router';
import ENV from '../../../../../env.json';
import { useStandaloneAppContext } from '../../../../hooks/useStandaloneAppContext';
import { PAGES } from '../../../../sitemap';

const TRACK_PROD = true;

const isLocalhost = () => window.location.host.startsWith('localhost');

const getPageName = (currentPath: string) => {
  const currentPage = PAGES.find((p) =>
    matchPath(currentPath, {
      // don't bother about the other elements of p,
      // we override render ourselves, so it wouldn't be
      // compatible to be passed straight down here.
      path: p.path,
      exact: true
    })
  );
  return currentPage?.trackingName || 'Unknown';
};

export const trackEmployeeAppEvent = (
  accessToken: string,
  event: ProductAnalyticsEvent
) => {
  console.log('TRACKING_PA_EVENT', event);

  if (ENV.env.name !== 'Development' && !TRACK_PROD) {
    return;
  }
  const u = new URL(
    isLocalhost() ? ENV.domains.cf.public : window.location.origin
  );
  const pathname = window.location.pathname;
  const impersonate = window.location.search.includes('impersonate=true');
  const args = {
    accessToken,
    event,
    currentPage: {
      name: getPageName(pathname),
      path: pathname
    },
    trackInternalUsers: true,
    impersonate
  };
  const d = btoa(unescape(encodeURIComponent(JSON.stringify(args, null, 0))));
  u.pathname = isLocalhost()
    ? 'productAnalytics_trackEmployeeAppEvent'
    : '/api/product_analytics/track_event';
  u.searchParams.set('d', d);
  return fetch(u.toString())
    .then(() => null)
    .catch((err) => {
      console.log('TRACKING_PA_EVENT_ERROR', err);
    });
};

export const trackEmployeeAppEventV2 = (
  userAccessToken: string,
  event: ProductAnalyticsEventV2
) => {
  console.log('TRACKING_PA_EVENT_V2', event);

  if (ENV.env.name !== 'Development' && !TRACK_PROD) {
    return;
  }
  const u = new URL(
    isLocalhost() ? ENV.domains.cf.public : window.location.origin
  );
  const pathname = window.location.pathname;
  const impersonate = window.location.search.includes('impersonate=true');
  const args = {
    userAccessToken,
    event,
    currentPage: {
      name: getPageName(pathname),
      path: pathname
    },
    trackInternalUsers: true,
    impersonate
  };
  const d = btoa(unescape(encodeURIComponent(JSON.stringify(args, null, 0))));
  u.pathname = isLocalhost()
    ? 'productAnalytics_trackEmployeeAppEventV2'
    : '/api/product_analytics/track_event_v2';
  u.searchParams.set('d', d);
  return fetch(u.toString())
    .then(() => null)
    .catch((err) => {
      console.log('TRACKING_PA_EVENT_V2_ERROR', err);
    });
};
// TODO inline accessToken into the context provider somehow, so that
// we don't have to bother about passing it here.
// Then the interface would really be uniform to the admin app
export const useProductAnalytics = (accessToken: string) => {
  const {
    productAnalytics: { trackEvent }
  } = useStandaloneAppContext();
  return useMemo(() => {
    return {
      trackEvent: (event: ProductAnalyticsEvent) =>
        trackEvent(accessToken, event)
    };
  }, [trackEvent, accessToken]);
};

export const useProductAnalyticsV2 = (userAccessToken: string) => {
  const {
    productAnalytics: { trackEventV2 }
  } = useStandaloneAppContext();
  return useMemo(() => {
    return {
      trackEventV2: (event: ProductAnalyticsEventV2) =>
        trackEventV2(userAccessToken, event)
    };
  }, [trackEventV2, userAccessToken]);
};
